if (!customElements.get('grejora-sticky-atc')) {
  customElements.define(
    'grejora-sticky-atc',
    class GrejoraStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.priceContainer = document.getElementById(`price-${this.sectionId}`);
        this.priceTarget = this.querySelector('[data-sticky-price]');
        this.labelTarget = this.querySelector('[data-sticky-label]');
        this.button = this.querySelector('[data-sticky-button]');

        if (!this.submitButton || !this.button) return;

        this.button.addEventListener('click', () => {
          if (!this.submitButton.disabled) this.submitButton.click();
        });

        this.syncFromForm = this.syncFromForm.bind(this);
        this.syncFromForm();

        // Mirror label/disabled state and price after variant changes re-render the form.
        this.mutationObserver = new MutationObserver(this.syncFromForm);
        this.mutationObserver.observe(this.submitButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.priceContainer) {
          this.mutationObserver.observe(this.priceContainer, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        // Show the bar only after the real buy button leaves the viewport upwards.
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggleAttribute('hidden', !scrolledPast);
          });
        });
        this.intersectionObserver.observe(this.submitButton);
      }

      disconnectedCallback() {
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
      }

      syncFromForm() {
        const label = this.submitButton.querySelector('span');
        if (label && this.labelTarget) this.labelTarget.textContent = label.textContent.trim();
        this.button.disabled = this.submitButton.disabled;

        if (!this.priceContainer || !this.priceTarget) return;
        const priceWrapper = this.priceContainer.querySelector('.price');
        if (!priceWrapper) return;
        const selector = priceWrapper.classList.contains('price--on-sale')
          ? '.price__sale .price-item--sale'
          : '.price__regular .price-item--regular';
        const priceItem = priceWrapper.querySelector(selector);
        if (priceItem) this.priceTarget.textContent = priceItem.textContent.trim();
      }
    }
  );
}
